import regions from '../data/regions.json';

export function getPlanRegion(planId) {
  if (typeof planId !== 'string') return null;

  const regionValue = planId.split('-')[1];
  if (!regionValue) return null;

  return regions.find((region) => region.value === regionValue) || null;
}

export function getPlanRegionLabel(planId) {
  return getPlanRegion(planId)?.label || '';
}
